import { render, staticRenderFns } from "./AddEmpleadoParaNotificar.vue?vue&type=template&id=b4c9ec42&"
import script from "./AddEmpleadoParaNotificar.vue?vue&type=script&lang=js&"
export * from "./AddEmpleadoParaNotificar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports